export default __webpack_public_path__ + "static/media/av2.9ca6f458.jpg";